// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f0596dd2","513":"ba9719c5","703":"f5128ee6","787":"c6006e9a"}[chunkId] + ".chunk.js";
};